import React, { useEffect, useRef, useState } from 'react';
import Image from '../Image';
import steps from '../../global/texts/setupSteps';
import Button from '../Button/Button';
import './StaticSteps.scss';
import leftArrow from '../../Assets/images/Activation/left-arrow.svg';
import rightArrow from '../../Assets/images/Activation/right-arrow.svg';
import androidLightIcon from '../../Assets/images/Activation/androidLight.svg';
import androidDarkIcon from '../../Assets/images/Activation/androidDark.svg';
import macLightIcon from '../../Assets/images/Activation/macLight.svg';
import macDarkIcon from '../../Assets/images/Activation/macDark.svg';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Checkbox, CircularProgress } from '@material-ui/core';
import { globalVal } from '../../global/globalvalues';
import SimpleHeader from '../../components/Header/simpleHeader';
import Footer from '../Footer/Footer';
import BannerImg from '../../Assets/images/Activation/activationBanner.webp';
import BannerIpadImg from '../../Assets/images/Activation/activationBannerIPad.webp';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateCustomerSource } from '../../store/Checkout/actions';
import { resendStatus } from '../../store/Activation/actions';
import BackButton from '../../Assets/images/commonImages/backButton.svg';
import { customerGroup } from '../../store/PostActivation/actions';
// import { pushTrackingEventsToGAAndFBNew } from '../../global/commonFunctions/GaAndFb';
import TagManager from 'react-gtm-module';

type Props = {
    ios?: boolean;
    android?: boolean;
    history?: any;
};

const StaticSteps = (props: Props) => {
    const [stepCount, setStepCount] = useState<number>(1);
    const [stepImgCount, setStepImgCount] = useState<number>(0);
    const [sliceStartCount, setSliceStartCount] = useState<number>(0);
    const [sliceEndCount, setSliceEndCount] = useState<number>(4);
    const [counterStart, setCounterStart] = useState<number>(0);
    const [counterEnd, setCounterEnd] = useState<number>(1);
    const [ios, setIos] = useState<boolean>(true);
    const [android, setAndroid] = useState<boolean>(false);
    const [currentUser, setCurrentUser] = useState<any>('');
    const [confirmed, setConfirmed] = useState<boolean>(false);
    const [isResendKitClicked, setIsResendKitClicked] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { checkout } = useSelector((state: any) => state);

    useEffect(() => {
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        if (secondaryCustomer) {
            setCurrentUser(secondaryCustomer);
        } else {
            setCurrentUser(customerDetail);
        }
        if (window.matchMedia('(max-width: 600px)').matches) {
            setSliceEndCount(2);
        }
    }, []);

    useEffect(() => {
        setStepImgCount(0);
        setStepCount(1);
        setSliceStartCount(0);
        setSliceEndCount(4);
        setCounterStart(0);
        setCounterEnd(1);
    }, [ios, android]);

    const initialRender1 = useRef(true);
    useEffect(() => {
        if (initialRender1.current === true) {
            initialRender1.current = false;
        } else {
            const updateCustomer = checkout.updateCustomerSource;
            if (updateCustomer && updateCustomer.status === 'SUCCESS' && updateCustomer.data) {
                setLoader(false);
                dispatch(customerGroup({ groupId: currentUser && currentUser.groupId }));
                props.history.push('/post-activation-home');
            }
        }
    }, [checkout.updateCustomerSource]);

    const handlePrevSteps = () => {
        setStepImgCount(stepImgCount - 1);
        if (stepImgCount === 1 || stepImgCount === 6) return;
        if (window.matchMedia('(max-width: 600px)').matches) {
            if (stepCount === 3 || stepCount === 5) {
                setSliceStartCount(sliceStartCount - 2);
                setSliceEndCount(sliceEndCount - 2);
            } else if (stepCount === 7) {
                setSliceStartCount(4);
                setSliceEndCount(6);
            }
        } else {
            if (stepCount < 6) {
                setSliceStartCount(0);
                setSliceEndCount(4);
            }
        }
        setStepCount(stepCount - 1);
        setCounterEnd(prevState => prevState - 1);
        setCounterStart(prevState => prevState - 1);
    };
    const handleNextSteps = () => {
        if (stepCount >= (ios && steps.ios.length ? steps.ios.length : steps.android.length)) {
            return;
        }

        setStepImgCount(stepImgCount + 1);

        if (window.matchMedia('(max-width: 600px)').matches) {
            if (stepCount === 2 || stepCount === 4) {
                setSliceStartCount(sliceStartCount + 2);
                setSliceEndCount(sliceEndCount + 2);
            } else if (stepCount === 6) {
                setSliceStartCount(5);
                setSliceEndCount(7);
            }
        } else {
            if (stepCount > 3) {
                setSliceStartCount(3);
                setSliceEndCount(7);
            }
        }
        if (!stepImgCount || stepImgCount === 5) return;
        setStepCount(stepCount + 1);
        setCounterEnd(prevState => prevState + 1);
        setCounterStart(prevState => prevState + 1);
    };

    const continueHandler = () => {
        setLoader(true);
        const updatedValue = {
            eSimSetup: true,
            activationJourneyStatus: 'COMPLETED',
        };
        dispatch(
            UpdateCustomerSource({
                customerId: currentUser?.id,
                data: updatedValue,
            }),
        );
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        let occurence = currentUser.peerAccountRef.split('|')[2];
        // GAAndFBEventsHandler("SetupDone", customerDetail?.meta?.customer_statement_number, occurence)
        TagManager.dataLayer({
            dataLayer: {
                event: "Setup_Done",
                accountNo: customerDetail?.meta?.customer_statement_number,
                line_number: occurence,
            },
          });
    };
    const resendKit = () => {
        setIsResendKitClicked(false);
        dispatch(resendStatus({ customerId: currentUser.id }));
    };
    // const GAAndFBEventsHandler = (buttonVal: string, accNumber?: any, lineNumber?:any, size?:any) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "home",
    //       buttonValue: buttonVal, 
    //       accNumber: accNumber,
    //       lineNumber: lineNumber,
    //       data: size,
    //     });
    //   };

    let customerDetail: any = localStorage.getItem('customerDetail');
    customerDetail = JSON.parse(customerDetail);
    return (
        <div className="stepsMainDiv">
            <SimpleHeader history={props.history} user={currentUser} isHelp={true} />
            <div className="bannerImg">
                <img src={BannerImg} alt="img" className="WebImg" />
                <img src={BannerIpadImg} alt="img" className="IpadImg" />
                {/* <img src={BannerMWebImg} alt="img" className="MWebImg" /> */}
                <div className="contentCarousel">
                    <div className="Goodbye-mobile-store">Activation</div>
                </div>
            </div>
            {isResendKitClicked ? (
                <div className="resendKitContainer">
                    <div className="resendKitTitle">
                        <img
                            src={BackButton}
                            alt="back"
                            className="resendKitBackArrow"
                            onClick={() => setIsResendKitClicked(false)}
                        />
                        <div className="stepsHeading">Resend eSIM Kit</div>
                    </div>
                    <div className="resendKitMsg">
                        Your Astound Mobile eSIM Kit, including your activation QR code, will be resent to{' '}<br />
                        <span>{customerDetail?.emailId}</span>
                    </div>
                    <Button primary={true} onClick={resendKit}>
                        RESEND
                    </Button>
                </div>
            ) : (
                <>
                    <div className="stepsHeading">Set Up Profile Using QR Code</div>
                    <div className="ProgressBarActivation">
                        <div className="stepsCount">Step 4 of 4</div>
                        <ProgressBar variant="success" now={100} className="progressBar" />
                    </div>
                    <div>
                        <div className="herehow">Here's how you can download your eSIM profile:</div>
                        <div className="note">
                            Your line is activated and your eSIM Kit will reach your inbox on {" "}
                            <span>
                                {customerDetail?.emailId}
                            </span>
                        </div>
                    </div>
                    <div className="stepsBox">
                        <div className="btns">
                            <div
                                className={ios ? 'activeBtn' : 'inActiveBtn'}
                                onClick={() => {
                                    setIos(true);
                                    setAndroid(false);
                                }}
                            >
                                <img src={ios ? macDarkIcon : macLightIcon} style={{ marginRight: '10px' }} />
                                <div className="btnText" style={{ color: ios ? '#009C86' : '#9c9c9c' }}>
                                    iOS
                                </div>
                            </div>
                            <div
                                className={android ? 'activeBtn' : 'inActiveBtn'}
                                onClick={() => {
                                    setIos(false);
                                    setAndroid(true);
                                }}
                            >
                                <div>
                                    <img
                                        src={android ? androidDarkIcon : androidLightIcon}
                                        style={{ marginRight: '10px' }}
                                    />
                                </div>
                                <div className="btnText" style={{ color: android ? '#009C86' : '#9c9c9c' }}>
                                    Android
                                </div>
                            </div>
                        </div>
                        <div className="stepContainer">
                            <div className="img">
                                <Image
                                    className="web"
                                    src={ios ? steps.ios_images[stepImgCount] : steps.android_images[stepImgCount]}
                                />
                                <div className="stepsCard">
                                    {steps[ios ? 'ios' : 'android']
                                        .slice(sliceStartCount, sliceEndCount)
                                        .map((data: any, index: any) => {
                                            return (
                                                <div key={index} className="stepsContainer">
                                                    <div className="stepsText">
                                                        {stepCount === data.step && (
                                                            <div
                                                                className={
                                                                    !stepImgCount
                                                                        ? 'verticalLineSteps greenVerticalLineSteps'
                                                                        : 'verticalLineSteps'
                                                                }
                                                            ></div>
                                                        )}
                                                        <div className="stepsContent">
                                                            <div
                                                                className={`stepsTitle ${
                                                                    !stepImgCount && stepCount === data.step
                                                                        ? 'step1UnSelected'
                                                                        : stepCount === data.step
                                                                        ? 'selectedTitle'
                                                                        : 'unSelectedTitle'
                                                                }`}
                                                            >
                                                                <span className="stepNum">{data.step}</span>
                                                                {data.title}
                                                            </div>
                                                            <div
                                                                className={`stepsDesc ${
                                                                    stepCount === data.step
                                                                        ? 'selectedDesc'
                                                                        : 'unSelectedDesc'
                                                                }`}
                                                            >
                                                                {data.spanTxt && (
                                                                    <>
                                                                        {data.spanTxt}
                                                                        <span className="boldTxt">{data.boldTxt}</span>
                                                                    </>
                                                                )}
                                                                {data.desc} {data.desc_newline && <br />}
                                                                {data.desc_newline}{' '}
                                                                {data.boldTxt && !data.spanTxt && (
                                                                    <span className="boldTxt">{data.boldTxt}</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                            <div className="navigations">
                                <div className="leftBtn">
                                    <Button onClick={handlePrevSteps} disabled={!stepImgCount ? true : false}>
                                        <img src={leftArrow} alt="" />
                                    </Button>
                                </div>
                                <div className="rightBtn">
                                    <Button
                                        onClick={handleNextSteps}
                                        disabled={
                                            stepCount >=
                                            (ios && steps.ios.length ? steps.ios.length : steps.android.length)
                                                ? true
                                                : false
                                        }
                                    >
                                        <img src={rightArrow} alt="" />
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="stepContainerMWeb">
                            <div className="img">
                                <Image
                                    className="web"
                                    src={ios ? steps.ios_images[stepImgCount] : steps.android_images[stepImgCount]}
                                />
                                <div className="navigations">
                                    <div className="leftBtn">
                                        <Button onClick={handlePrevSteps} disabled={!stepImgCount ? true : false}>
                                            <img src={leftArrow} className={'mb-2'} alt="" />
                                        </Button>
                                    </div>
                                    <div className="rightBtn">
                                        <Button
                                            onClick={handleNextSteps}
                                            disabled={
                                                stepCount >=
                                                (ios && steps.ios.length ? steps.ios.length : steps.android.length)
                                                    ? true
                                                    : false
                                            }
                                        >
                                            <img src={rightArrow} className={'mb-2'} alt="" />
                                        </Button>
                                    </div>
                                </div>
                                <div className="stepsCard">
                                    {steps[ios ? 'ios' : 'android']
                                        .slice(counterStart, counterEnd)
                                        .map((data: any, index: any) => {
                                            return (
                                                <div key={index} className="stepsContainer">
                                                    {stepCount === data.step && (
                                                        <div className="greenLineVertical"></div>
                                                    )}
                                                    <div className="stepsText">
                                                        <div
                                                            className={`stepsTitle ${
                                                                stepCount === data.step
                                                                    ? 'selectedTitle'
                                                                    : 'unSelectedTitle'
                                                            }`}
                                                        >
                                                            <span className="stepNum">{data.step}</span>
                                                            {data.title}
                                                        </div>
                                                        <div
                                                            className={`stepsDesc ${
                                                                stepCount === data.step
                                                                    ? 'selectedDesc'
                                                                    : 'unSelectedDesc'
                                                            }`}
                                                        >
                                                            {data.spanTxt && (
                                                                <>
                                                                    {data.spanTxt}
                                                                    <span className="boldTxt">{data.boldTxt}</span>
                                                                </>
                                                            )}
                                                            {data.desc} {data.desc_newline && <br />}
                                                            {data.desc_newline}{' '}
                                                            {data.boldTxt && !data.spanTxt && (
                                                                <span className="boldTxt">{data.boldTxt}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="confirmation">
                        <Checkbox className="switchBtn" onChange={(e: any) => setConfirmed(e.target.checked)} />
                        I have completed the eSIM setup.
                    </div>
                    <div className="confirmBtn">
                        <Button primary={true} disabled={!confirmed ? true : false} onClick={continueHandler}>
                            {loader ? (
                                <div className="loader-check text-center">
                                    <CircularProgress color="inherit" />
                                </div>
                            ) : (
                                'Done'
                            )}
                        </Button>
                    </div>
                    <div className="line" style={{ width: '100%', marginBottom: '20px' }}></div>
                    <div className="unableToFindText">
                        Unable to find your {globalVal?.short_name} digital Activation Kit?
                        <br /> Please check your spam/junk folder as well.
                    </div>
                    {
                        // isResendKitClicked ?
                        //     <div className="loader">
                        //         <CircularProgress color="inherit" />
                        //     </div>
                        //     :
                        <div className="resend" 
                            onClick={() => {
                                setIsResendKitClicked(true)
                                let occurence = currentUser.peerAccountRef.split('|')[2];
                                // GAAndFBEventsHandler("Resend", customerDetail?.meta?.customer_statement_number, occurence)
                                TagManager.dataLayer({
                                    dataLayer: {
                                        event: "Resend",
                                        accountNo: customerDetail?.meta?.customer_statement_number,
                                        line_number: occurence,
                                    },
                                  });
                            }}
                        >
                            Resend eSIM kit
                        </div>
                    }
                </>
            )}
            <Footer isFixed={true} />
        </div>
    );
};

export default StaticSteps;
